/**
 * Étapes du questionnaire patrimonial.
 * Source unique partagée entre le formulaire (FormApat) et le tableau de bord,
 * qui affiche l'avancement à partir du `wizardStepId` du brouillon serveur.
 */
export const WIZARD_STEPS = [
  { id: 'page1_profile', label: 'Profil & identité', phase: 'profile' },
  { id: 'page2_coordonnees', label: 'Coordonnées', phase: 'questionnaire' },
  { id: 'page2b_situation', label: 'Situation familiale', phase: 'questionnaire' },
  { id: 'page2c_patrimoine', label: 'Patrimoine immobilier', phase: 'questionnaire' },
  { id: 'page2d_activites', label: 'Activités professionnelles', phase: 'questionnaire' },
  { id: 'page3_finances', label: 'Avoirs financiers', phase: 'questionnaire' },
  { id: 'page3b_passifs_revenus', label: 'Revenus & passifs', phase: 'questionnaire' },
  { id: 'page3c_charges_1', label: 'Charges — Logement, transport, assurance', phase: 'questionnaire' },
  { id: 'page3c_charges_2', label: 'Charges — Animaux, soins, loisirs', phase: 'questionnaire' },
  { id: 'page3c_charges_3', label: 'Charges — Épargne, impôts', phase: 'questionnaire' },
  { id: 'page3c_charges_4', label: 'Charges — Études, dons', phase: 'questionnaire' },
  { id: 'page4_objectifs', label: 'Objectifs', phase: 'questionnaire' },
  { id: 'page5_documents_payment', label: 'Justificatifs', phase: 'documents' },
  { id: 'page6_submit', label: 'Validation finale', phase: 'submit' },
];

/** Identifiants d'étapes historiques présents dans d'anciens brouillons. */
export const LEGACY_WIZARD_STEP_MAP = {
  offer: 'page1_profile',
  personal: 'page1_profile',
  kyc_wait: 'page3_finances',
  coordonnees: 'page2_coordonnees',
  situation: 'page2b_situation',
  immobilier: 'page2c_patrimoine',
  activites: 'page2d_activites',
  avoirs: 'page3_finances',
  passifs: 'page3b_passifs_revenus',
  revenus: 'page3b_passifs_revenus',
  charges: 'page3c_charges_1',
  page3c_charges: 'page3c_charges_1',
  objectifs: 'page4_objectifs',
  submit: 'page6_submit',
  // 'page2_situation' regroupait Coordonnées + Situation + Patrimoine + Activités
  // avant leur scission en 4 étapes : un brouillon déjà entamé avec ce
  // wizardStepId est rattrapé plus finement dans migrateWizardStepId()
  // (FormApat.vue), via mobileSections, plutôt que via ce mapping statique.
  page2_situation: 'page2_coordonnees',
  page2_questionnaire: 'page2_coordonnees',
  page3_objectifs: 'page4_objectifs',
  page4_documents_payment: 'page5_documents_payment',
  page5_submit: 'page6_submit',
};

export const WIZARD_STEP_TOTAL = WIZARD_STEPS.length;

export function normalizeWizardStepId(rawId) {
  const id = String(rawId || '').trim();
  if (!id) return null;
  const mapped = LEGACY_WIZARD_STEP_MAP[id] || id;
  return WIZARD_STEPS.some((step) => step.id === mapped) ? mapped : null;
}

/** Numéro d'étape 1-indexé, `0` si l'étape est inconnue ou absente. */
export function wizardStepNumber(rawId) {
  const id = normalizeWizardStepId(rawId);
  if (!id) return 0;
  return WIZARD_STEPS.findIndex((step) => step.id === id) + 1;
}

export function wizardStepLabel(rawId) {
  const id = normalizeWizardStepId(rawId);
  return WIZARD_STEPS.find((step) => step.id === id)?.label || '';
}
